// File Type Icons - VS Code style
import React from 'react';
import {
  FileCode,
  FileText,
  FileJson,
  File,
  Settings,
  Database,
  Image,
  FileCheck
} from 'lucide-react';

export const getFileIcon = (filename: string, className: string = "w-4 h-4") => {
  const ext = filename.split('.').pop()?.toLowerCase();
  const name = filename.toLowerCase();

  // Configuration files
  if (name === 'package.json' || name === 'package-lock.json') {
    return <FileJson className={`${className} text-yellow-500`} />;
  }
  if (name === 'tsconfig.json' || name === 'jsconfig.json') {
    return <Settings className={`${className} text-blue-500`} />;
  }
  if (name.includes('config') || name.includes('.env')) {
    return <Settings className={`${className} text-gray-500`} />;
  }

  // TypeScript
  if (ext === 'ts' || ext === 'tsx') {
    return <FileCode className={`${className} text-blue-500`} />;
  }

  // JavaScript
  if (ext === 'js' || ext === 'jsx' || ext === 'mjs' || ext === 'cjs') {
    return <FileCode className={`${className} text-yellow-500`} />;
  }

  // JSON
  if (ext === 'json') {
    return <FileJson className={`${className} text-yellow-600`} />;
  }

  // Markdown
  if (ext === 'md' || ext === 'markdown') {
    return <FileText className={`${className} text-blue-400`} />;
  }

  // HTML
  if (ext === 'html' || ext === 'htm') {
    return <FileCode className={`${className} text-orange-500`} />;
  }

  // CSS
  if (ext === 'css' || ext === 'scss' || ext === 'sass' || ext === 'less') {
    return <FileCode className={`${className} text-blue-400`} />;
  }

  // Images
  if (['png', 'jpg', 'jpeg', 'gif', 'svg', 'webp'].includes(ext || '')) {
    return <Image className={`${className} text-green-500`} />;
  }

  // Database
  if (['sql', 'db', 'sqlite'].includes(ext || '')) {
    return <Database className={`${className} text-blue-600`} />;
  }

  // Test files
  if (name.includes('test') || name.includes('spec')) {
    return <FileCheck className={`${className} text-green-600`} />;
  }

  // Default
  return <File className={`${className} text-gray-500`} />;
};

